import React, { useMemo } from "react";
import { ElasticProduct } from "@usereactify/search";

import { useShopify } from "@app/scripts/react-hooks/shopify";
import { ProductCard } from "@app/scripts/react-product/components/ProductCard";

type Props = {
  product: ElasticProduct;
  handlePageSizeStorage?: () => void;
};

function filterAndConcatPrice(obj: ElasticProduct) {
  if (!obj || !obj.variants || !Array.isArray(obj.variants)) {
    return obj;
  }

  const uniqueIds = new Set();
  obj.variants = obj.variants
    .filter((variant) => {
      if (!uniqueIds.has(variant.id)) {
        uniqueIds.add(variant.id);
        return true;
      }
      return false;
    })
    .map((variant) => {
      if (variant.title === "OS") {
        return { ...variant, title: "$" + variant.price };
      }
      return variant;
    })
    .sort((a, b) => {
      if (a.title === "$" && b.title === "$") {
        return a.price - b.price;
      } else if (a.title === "$") {
        return -1;
      } else if (b.title === "$") {
        return 1;
      }
      return 0;
    });

  return obj;
}

export const ResultCardProduct: React.FC<Props> = ({ product, handlePageSizeStorage }) => {

  // TODO remove this when gift card data is fixed and OS variant titles rectified
  let filteredGiftCards: ElasticProduct | null = null;
  if (product.handle.includes("50-gift-card")) {
    //@ts-ignore
    filteredGiftCards = filterAndConcatPrice(product);
  }

  const { normaliseElasticProduct } = useShopify();

  const normalised = useMemo(
    () => normaliseElasticProduct(filteredGiftCards ? filteredGiftCards : product),
    [normaliseElasticProduct, product]
  );
  return product ? <ProductCard product={normalised} hasQuickAddDrawer={true} quickAddStyle="plp" handlePageSizeStorage={handlePageSizeStorage} /> : null;
};
